import React, {useEffect, useRef, useState} from 'react';
import YuJaButton from './standardization/YuJaButton';
import classes from "./FilterMenu.module.css";
import { ReactComponent as Filter } from "../images/filter.svg";
import { ReactComponent as ARROW_RIGHT } from "../images/arrow_right_black.svg";
import {YuJaCheckbox} from "./standardization/YuJaCheckbox";
import YuJaDatePicker from "./YuJaDatePicker";
import { Popover } from '@base-ui/react/popover';
import {Button} from "@base-ui/react/button";
import {Separator} from "@base-ui/react/separator";
import { useTranslation } from "react-i18next";
import { translateDisplayValue } from "../utils/displayLabel";

/**
 * filterOptions extras (all optional):
 *  - separateDates: render dateFilter1/dateFilter2 as two independent rows titled with their own names,
 *    instead of one start -> end range under a single "Date" title
 * disabled: blocks opening and calls onDisabledOpen instead
 * className: extra class for the menu; use it to set --filter-menu-width / --filter-title-col / --filter-option-cols
 *   (see FilterMenu.module.css)
 */
export default function FilterMenuNew({ onApply, filterOptions, style={}, className="", disabled=false, onDisabledOpen}) {
    const { t } = useTranslation();
    const [optionFilter1, setOptionFilter1] = useState(filterOptions?.optionFilter1);
    const [optionFilter2, setOptionFilter2] = useState(filterOptions?.optionFilter2);
    const [optionFilter3, setOptionFilter3] = useState(filterOptions?.optionFilter3);
    const [dateFilter1, setDateFilter1] = useState(filterOptions?.dateFilter1);
    const [dateFilter2, setDateFilter2] = useState(filterOptions?.dateFilter2);
    const [total, setTotal] = useState(0);

    const popoverRef = useRef();


    const handleInputChange = (checked, event) => {
        const { name, value } = event.target;
        // console.log(name, value)
        switch (name) {
            case filterOptions?.optionFilter1Name:
                if (optionFilter1.includes(value)) {
                    setOptionFilter1(optionFilter1.filter(option => option !== value));
                } else {
                    setOptionFilter1([...optionFilter1, value]);
                }
                break;
            case filterOptions?.optionFilter2Name:
                if (optionFilter2.includes(value)) {
                    setOptionFilter2(optionFilter2.filter(option => option !== value));
                } else {
                    setOptionFilter2([...optionFilter2, value]);
                }
                break;
            case filterOptions?.optionFilter3Name:
                if (optionFilter3.includes(value)) {
                    setOptionFilter3(optionFilter3.filter(option => option !== value));
                } else {
                    setOptionFilter3([...optionFilter3, value]);
                }
                break;
            // case filterOptions?.dateFilter1Name:
            //     setDateFilter1(value);
            //     break;
            // case filterOptions?.dateFilter2Name:
            //     setDateFilter2(value);
            //     break;
            default:
                console.log('Error: Invalid filter name');
                break;
        }
    };

    const handleClear = () => {
        if (filterOptions?.optionFilter1Name) setOptionFilter1([]);
        if (filterOptions?.optionFilter2Name) setOptionFilter2([]);
        if (filterOptions?.optionFilter3Name) setOptionFilter3([]);
        if (filterOptions?.dateFilter1Name) setDateFilter1("");
        if (filterOptions?.dateFilter2Name) setDateFilter2("");
    };

    const handleApply = () => {

        onApply({
            optionFilter1: optionFilter1,
            optionFilter2: optionFilter2,
            optionFilter3: optionFilter3,
            dateFilter1: dateFilter1,
            dateFilter2: dateFilter2
        });
        close();
    };

    const close = () => {
        if (popoverRef.current) {
            popoverRef.current.close();
        }

    }


    useEffect(() => {
        let temp = 0;
        if (!!optionFilter1 && !!filterOptions?.optionsFilter1) {
            temp += optionFilter1.filter(i => filterOptions.optionsFilter1.includes(i)).length;
        }

        if (!!optionFilter2 && !!filterOptions?.optionsFilter2) {
            temp += optionFilter2.filter(i => filterOptions.optionsFilter2.includes(i)).length;
        }

        if (!!optionFilter3 && !!filterOptions?.optionsFilter3) {
            temp += optionFilter3.filter(i => filterOptions.optionsFilter3.includes(i)).length;
        }

        if (!!dateFilter1) {
            temp += 1;
        }

        if (!!dateFilter2) {
            temp += 1;
        }

        setTotal(temp);
    }, [optionFilter1, optionFilter2, optionFilter3, dateFilter1, dateFilter2, filterOptions]);

    return (

      <Popover.Root
          modal={"trap-focus"}
          actionsRef={popoverRef}
          onOpenChange={(isOpen, eventDetails) => {
              if (isOpen && disabled) {
                  eventDetails.cancel();
                  if (!!onDisabledOpen) {
                      onDisabledOpen();
                  }
              }
          }}
          onOpenChangeComplete={() => {
              setOptionFilter1(filterOptions?.optionFilter1);
              setOptionFilter2(filterOptions?.optionFilter2);
              setOptionFilter3(filterOptions?.optionFilter3);
              setDateFilter1(filterOptions?.dateFilter1);
              setDateFilter2(filterOptions?.dateFilter2);
          }}
      >
          <Popover.Trigger id={"filter-btn"} aria-label={t("poll.filterButtonText")} className={classes.filterIcon}>
              <Filter style={{width: 28, height: 28}}/>
              {!!total &&
                  <span className={classes.filterCounter}>{total}</span>
              }
          </Popover.Trigger>
          <Popover.Portal>
              <Popover.Positioner sideOffset={8} side="bottom" align="start">
                  <Popover.Popup>
                      <div className={`${classes.filterMenu} ${className}`} style={style}>
                          <div className={classes.filterHeader} style={{marginBottom: 15}}>
                              <span className={classes.filterCount}>{t("common.filterTotal", {total})}</span>
                              <div style={{flex: 1}}/>
                              <Button className={classes.link} onClick={handleClear}>
                                  {t("questionBank.clearAllText")}
                              </Button>
                          </div>
                          {/* One grid for the whole body: column 1 = titles, column 2 = options / date pickers.
                              Every section shares the same two columns, so nothing needs manual alignment. */}
                          <div
                              className={`${classes.filterBody} ${classes.filterBodyGrid}`}
                          >
                              {/* Option Filter 1 */}
                              {filterOptions?.optionFilter1Name &&
                                  <>
                                      <div className={classes.filterTitle}>
                                          {filterOptions.optionFilter1Name}
                                      </div>
                                      <div className={classes.filterOptions}>
                                          {filterOptions.optionsFilter1.map((option, index) => (
                                              <YuJaCheckbox
                                                  key={index}
                                                  id={`optionFilter1-${index}`}
                                                  name={filterOptions.optionFilter1Name}
                                                  label={translateDisplayValue(option)}
                                                  style={{fontSize: 14, color: "#4D4D4D"}}
                                                  onChange={handleInputChange}
                                                  value={option}
                                                  checked={optionFilter1.includes(option)}
                                                  // disabled={optionFilter2 &&
                                                  //     ((option === SURVEY && optionFilter2.includes(SCHEDULED))
                                                  //         || (option === ATTENDANCE &&
                                                  //             (optionFilter2.includes(UNFINISHED)
                                                  //                 || optionFilter2.includes(SCHEDULED)
                                                  //                 || optionFilter2.includes(SHARED_BY_QUESTION)))
                                                  //         || (isPPT && option === MERGED_MODE && optionFilter2.includes(SHARED_ENTIRELY)))
                                                  // }
                                              />
                                          ))}
                                      </div>
                                  </>

                              }
                              {/* Option Filter 2 */}
                              {filterOptions?.optionFilter2Name &&
                                  <>
                                      <Separator className={`${classes.divider} ${classes.filterDivider}`}/>
                                      <div className={classes.filterTitle}>
                                          {filterOptions.optionFilter2Name}
                                      </div>
                                      <div className={classes.filterOptions}>
                                          {filterOptions.optionsFilter2.map((option, index) => (
                                              <YuJaCheckbox
                                                  key={index}
                                                  id={`optionFilter2-${index}`}
                                                  name={filterOptions.optionFilter2Name}
                                                  label={translateDisplayValue(option)}
                                                  style={{fontSize: 14, color: "#4D4D4D"}}
                                                  onChange={handleInputChange}
                                                  value={option}
                                                  checked={optionFilter2.includes(option)}
                                                  // disabled={optionFilter1 &&
                                                  //     ((option === SCHEDULED && optionFilter1.includes(SURVEY))
                                                  //         || (optionFilter1.includes(ATTENDANCE)
                                                  //             && (option === UNFINISHED
                                                  //                 || option === SHARED_BY_QUESTION
                                                  //                 || option === SCHEDULED))
                                                  //         || (isPPT && optionFilter1.includes(MERGED_MODE) && option === SHARED_ENTIRELY))
                                                  // }
                                              />
                                          ))}
                                      </div>
                                  </>

                              }

                              {/* Option Filter 3 */}
                              {filterOptions?.optionFilter3Name &&
                                  <>
                                      <Separator className={`${classes.divider} ${classes.filterDivider}`}/>
                                      <div className={classes.filterTitle}>{filterOptions.optionFilter3Name}</div>
                                      <div className={`${classes.row} ${classes.filterOptionsWrap}`}>
                                          {filterOptions.optionsFilter3.map((option, index) => (
                                              <YuJaCheckbox
                                                  key={index}
                                                  id={`optionFilter3-${index}`}
                                                  name={filterOptions.optionFilter3Name}
                                                  label={translateDisplayValue(option)}
                                                  style={{fontSize: 14, color: "#4D4D4D"}}
                                                  onChange={handleInputChange}
                                                  value={option}
                                                  checked={optionFilter3.includes(option)}
                                              />
                                          ))}
                                      </div>
                                  </>
                              }

                              {filterOptions?.separateDates && (filterOptions?.dateFilter1Name || filterOptions?.dateFilter2Name) &&
                                  <>
                                      <Separator className={`${classes.divider} ${classes.filterDivider}`}/>
                                      {filterOptions?.dateFilter1Name &&
                                          <>
                                              <div className={`${classes.filterTitle} ${classes.filterTitleCenter}`}>
                                                  {filterOptions.dateFilter1Name}
                                              </div>
                                              <div className={classes.filterDateCell}>
                                                  <YuJaDatePicker
                                                      date={dateFilter1}
                                                      ariaLabel={filterOptions.dateFilter1Name}
                                                      onChange={value => setDateFilter1(!!value ? value : "")}
                                                  />
                                              </div>
                                          </>
                                      }
                                      {filterOptions?.dateFilter2Name &&
                                          <>
                                              <div className={`${classes.filterTitle} ${classes.filterTitleCenter}`}>
                                                  {filterOptions.dateFilter2Name}
                                              </div>
                                              <div className={classes.filterDateCell}>
                                                  <YuJaDatePicker
                                                      date={dateFilter2}
                                                      ariaLabel={filterOptions.dateFilter2Name}
                                                      onChange={value => setDateFilter2(!!value ? value : "")}
                                                  />
                                              </div>
                                          </>
                                      }
                                  </>
                              }

                              {!filterOptions?.separateDates && (filterOptions?.dateFilter1Name || filterOptions?.dateFilter2Name) &&
                                  <>
                                      <Separator className={`${classes.divider} ${classes.filterDivider}`}/>
                                      <div className={`${classes.filterTitle} ${classes.filterTitleCenter}`}>{t("common.dateLabel")}</div>
                                      <div className={`${classes.row} ${classes.filterDateCell}`}>
                                          {filterOptions?.dateFilter1Name &&
                                              <>
                                                  <YuJaDatePicker
                                                      date={dateFilter1}
                                                      onChange={value => {
                                                          if (!!value) {
                                                              setDateFilter1(value);
                                                          } else {
                                                              setDateFilter1("");
                                                          }
                                                      }}
                                                  />
                                                  <div style={{width: 5}}/>
                                              </>
                                          }

                                          {filterOptions?.dateFilter2Name &&
                                              <>
                                                  <ARROW_RIGHT style={{flexShrink: 0}}/>
                                                  <div style={{width: 5}}/>

                                                  <YuJaDatePicker
                                                      date={dateFilter2}
                                                      onChange={value => {
                                                          if (!!value) {
                                                              setDateFilter2(value);
                                                          } else {
                                                              setDateFilter2("");
                                                          }
                                                      }}
                                                  />
                                              </>
                                          }
                                      </div>
                                  </>
                              }
                          </div>


                          <div className={classes.filterFooter}>
                              <YuJaButton type="secondary" size={"small"} style={{fontSize: 13}} onClick={() => close()}>
                                  {t("common.cancel")}
                              </YuJaButton>
                              <YuJaButton style={{fontSize: 13}} size={"small"} onClick={handleApply}>{t("common.apply")}</YuJaButton>
                          </div>
                      </div>
                  </Popover.Popup>
              </Popover.Positioner>
          </Popover.Portal>
      </Popover.Root>
    );
}
